import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
// [Bug Report] Failed to resolve directive: ripple (https://github.com/vuetifyjs/vuetify/issues/12224)
import Ripple from 'vuetify/lib/directives/ripple';
// import RegulationNetworkIcon from '../components/main/RegulationNetworkIcon.vue'

import '@mdi/font/css/materialdesignicons.css';

// Vue use font-awesome
/* import the fontawesome core */
// import {
//     library
// } from '@fortawesome/fontawesome-svg-core';
// /* import font awesome icon component */
// import {
//     FontAwesomeIcon
// } from '@fortawesome/vue-fontawesome';
// /* import specific icons */
// import {
//     faProjectDiagram
// } from '@fortawesome/free-solid-svg-icons';
// Vue.component('font-awesome-icon', FontAwesomeIcon) // Register component globally
// library.add(faProjectDiagram) // Include needed icons

Vue.use(Vuetify, {
    directives: {
        Ripple
    },
    icons: {
        iconfont: ['mdi'],
        // iconfont: ['mdi', 'faSvg'],
        values: {
            // 'network': {
            //     component: RegulationNetworkIcon,
            // }
        }
    },
});

export default new Vuetify({});